import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";
import downloadEndpoint from "@/endpoints/download/downloadEndpoint";
import { axiosFileExtensions } from "@/global/constants";

const accessRoute = {
    DOWNLOAD_INVOICE_REPORT: "/reports/overview-report/detail-invoice",
    LIST_INVOICE_DETAIL: "/reports/overview-report/invoiceDetail/list",
    DOWNLOAD_COLLECTION_REPORT: "/reports/collected",
    LIST_COLLECTION: "/reports/collected/list",
    DOWNLOAD_PURGE_RECORD: "/reports/purge-record",
    LIST_PURGE_RECORD: "/reports/purge-record/list",
    DOWNLOAD_MONTHLY_ACTIVE: "/reports/overview-report/monthly-active",
    LIST_MONTHLY_ACTIVE: "/reports/overview-report/monthly-active/list",
    DOWNLOAD_INVOICE_BY_CONCEPT: "/reports/overview-report/concept-invoice",
    LIST_INVOICE_BY_CONCEPT: "/reports/overview-report/invoiceByConcept/list",
    DOWNLOAD_PRODUCT_REPORT: "/reports/overview-report/products",
    LIST_PRODUCTS: "/reports/overview-report/products-list",
    DOWNLOAD_CLOSURES_REPORT: "/reports/overview-report/closures",
    LIST_CLOSURES: "/reports/overview-report/closures-list",
    DOWNLOAD_FREQUENCY_PARKING: "/reports/frequency/document",
    PREVIEW_FREQUENCY_PARKING: "/reports/frequency/data",
    DOWNLOAD_PERMANENCE_PARKING: "/reports/permanence/document",
    PREVIEW_PERMANENCE_PARKING: "/reports/permanence/data",
    DOWNLOAD_CANCELLATION_INVOICE: "/reports/overview-report/cancel-invoice",
    PREVIEW_CANCELLATION_INVOICE: "/reports/overview-report/cancel-invoice/list",
    PREVIEW_ELECTRONIC_DETAIL: "/reports/overview-report/electronic-invoice/detail/",
    DOWNLOAD_AERORIENTE_REPORT: "/reports/overview-report/aerooriente",
    LIST_AEROORIENTE_REPORT: "/reports/overview-report/aerooriente-list",
}
export default {
    downloadInvoiceDetail(objParams) {
        return new Promise(resolve => {
            let newData = { code: -1 };
            http.get(accessRoute.DOWNLOAD_INVOICE_REPORT, {
                params: objParams
            }).then(({ data }) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });

    },
    listInvoiceDetail(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(accessRoute.LIST_INVOICE_DETAIL, {
                params: objParams
            }).then(({ data }) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    newData = data;
                    return;
                }
                if (!data.info.records || data.info.records.length === 0) {
                    toast.info("No se encontraron facturas con los criterios ingresados");
                    newData = data;
                    return;
                }
                newData = data;
            }).catch(() => toast.error("Error al consultar facturación"))
                .finally(() => resolve(newData));
        });
    },
    downloadCollection(objParams, fileName) {
        return downloadEndpoint.downloadFileByAxios(
            accessRoute.DOWNLOAD_COLLECTION_REPORT,
            axiosFileExtensions.XLSX.response,
            fileName,
            axiosFileExtensions.XLSX.extension,
            objParams);
    },
    listCollection(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(accessRoute.LIST_COLLECTION, {
                params: objParams
            }).then(({ data }) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    downloadPurgeRecords(objParams) {
        return new Promise(resolve => {
            let newData = { code: -1 };
            http.get(accessRoute.DOWNLOAD_PURGE_RECORD, {
                params: objParams
            }).then(({ data }) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },

    listPurgeRecords(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(accessRoute.LIST_PURGE_RECORD, {
                params: objParams
            }).then(({ data }) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },

    downloadMonthlyActive(objParams) {
        return new Promise(resolve => {
            let newData = { code: -1 };
            http.get(accessRoute.DOWNLOAD_MONTHLY_ACTIVE, {
                params: objParams
            }).then(({ data }) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });

    },
    listMonthlyActive(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(accessRoute.LIST_MONTHLY_ACTIVE, {
                params: objParams
            }).then(({ data }) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                if (!data.info.records || data.info.records.length === 0) {
                    toast.info("No se encontraron mensuales con los criterios ingresados");
                    return;
                }
                newData = data.info;
            }).catch(() => toast.error("Error al consultar mensualidades"))
                .finally(() => resolve(newData));
        });
    },

    downloadInvoiceByConcept(objParams) {
        return new Promise(resolve => {
            let newData = { code: -1 };
            http.get(accessRoute.DOWNLOAD_INVOICE_BY_CONCEPT, {
                params: objParams
            }).then(({ data }) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });

    },
    listInvoiceByConcept(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(accessRoute.LIST_INVOICE_BY_CONCEPT, {
                params: objParams
            }).then(({ data }) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    newData = data;
                    return;
                }
                if (!data.info.records || data.info.records.length === 0) {
                    toast.info("No se encontraron facturas con los criterios ingresados");
                    newData = data;
                    return;
                }
                newData = data;
            }).catch(() => toast.error("Error al consultar facturación"))
                .finally(() => resolve(newData));
        });
    },
    downloadProducts(objParams) {
        return new Promise(resolve => {
            let newData = { code: -1 };
            http.get(accessRoute.DOWNLOAD_PRODUCT_REPORT, {
                params: objParams
            }).then(({ data }) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    listProducts(objParams) {
        return new Promise(resolve => {
            let newData = [];
            http.get(accessRoute.LIST_PRODUCTS, {
                params: objParams
            }).then(({ data }) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                if (code === 0) {
                    toast.info("No se encontraron productos con los criterios ingresados");
                    return;
                }
                newData = data.info;
            }).catch(() => toast.error("Error al consultar productos"))
                .finally(() => resolve(newData));
        });
    },
    downloadClosures(objParams) {
        return new Promise(resolve => {
            let newData = { code: -1 };
            http.get(accessRoute.DOWNLOAD_CLOSURES_REPORT, {
                params: objParams
            }).then(({ data }) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    listClosures(objParams) {
        return new Promise(resolve => {
            let newData = [];
            http.get(accessRoute.LIST_CLOSURES, {
                params: objParams
            }).then(({ data }) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                if (code === 0) {
                    toast.info("No se encontraron cierres de caja con los criterios ingresados");
                    return;
                }
                newData = data.info;
            }).catch(() => toast.error("Error al consultar cierres de caja"))
                .finally(() => resolve(newData));
        });
    },
    previewParkingFrequency(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(accessRoute.PREVIEW_FREQUENCY_PARKING, {
                params: objParams
            }).then(({ data }) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    newData = data;
                    return;
                }
                if (code === 0) {
                    toast.info(data.message);
                    newData = data;
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    downloadParkingFrequency(objParams) {
        return new Promise(resolve => {
            let newData = { code: -1 };
            http.get(accessRoute.DOWNLOAD_FREQUENCY_PARKING, {
                params: objParams
            }).then(({ data }) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });

    },
    previewParkingPermanence(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(accessRoute.PREVIEW_PERMANENCE_PARKING, {
                params: objParams
            }).then(({ data }) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    newData = data;
                    return;
                }
                if (code === 0) {
                    toast.info(data.message);
                    newData = data;
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    downloadParkingPermanence(objParams) {
        return new Promise(resolve => {
            let newData = { code: -1 };
            http.get(accessRoute.DOWNLOAD_PERMANENCE_PARKING, {
                params: objParams
            }).then(({ data }) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });

    },
    previewCancellationInvoice(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(accessRoute.PREVIEW_CANCELLATION_INVOICE, {
                params: objParams
            }).then(({ data }) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    newData = data;
                    return;
                }
                if (code === 0) {
                    toast.info(data.message);
                    newData = data;
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    downloadCancellationInvoice(objParams) {
        return new Promise(resolve => {
            let newData = { code: -1 };
            http.get(accessRoute.DOWNLOAD_CANCELLATION_INVOICE, {
                params: objParams
            }).then(({ data }) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });

    },
    previewElectronicInvoice(documentId) {
        return new Promise(resolve => {
            let newData = {};
            http.get(accessRoute.PREVIEW_ELECTRONIC_DETAIL + documentId
            ).then(({ data }) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    newData = data;
                    return;
                }
                if (code === 0) {
                    toast.info(data.message);
                    newData = data;
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    downloadAeroriente(objParams) {
        return new Promise(resolve => {
            let newData = { code: -1 };
            http.get(accessRoute.DOWNLOAD_AERORIENTE_REPORT, {
                params: objParams
            }).then(({ data }) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });

    },
    previewAeroriente(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(accessRoute.LIST_AEROORIENTE_REPORT, {
                params: objParams
            }).then(({ data }) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    newData = data;
                    return;
                }
                if (code === 0) {
                    toast.info(data.message);
                    newData = data;
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
}
